module.exports = __webpack_public_path__ + "static/img/dd-customer-07.240e1c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-07.jpg
// module id = 61Yb
// module chunks = 1